/**
 * @generated SignedSource<<9ec83e209ccb6d8e63bc43df1dfef792>>
 * @relayHash 15d7acad258757e4608b0a07a6bde204
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8789ab3f986d4f369f91bdc4d71ace921807eaec7638f0e5dde21bdca1c34e17

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type uiVirtualAgentIntentTemplatesQuery$variables = {
  cloudId: string;
  isDiscoveredTemplatesTimestampEnabled: boolean;
  isGateIntentTemplatesBehindAiToggleEnabled: boolean;
  key: string;
};
export type uiVirtualAgentIntentTemplatesQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly " $fragmentSpreads": FragmentRefs<"content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef">;
    };
  };
  readonly virtualAgent: {
    readonly virtualAgentEntitlements: {
      readonly " $fragmentSpreads": FragmentRefs<"content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef">;
    };
  };
};
export type uiVirtualAgentIntentTemplatesQuery = {
  response: uiVirtualAgentIntentTemplatesQuery$data;
  variables: uiVirtualAgentIntentTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDiscoveredTemplatesTimestampEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGateIntentTemplatesBehindAiToggleEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v6 = [
  (v4/*: any*/)
],
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiVirtualAgentIntentTemplatesQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v5/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "isDiscoveredTemplatesTimestampEnabled",
                        "variableName": "isDiscoveredTemplatesTimestampEnabled"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplatesDataRef"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "VirtualAgentQueryApi",
          "kind": "LinkedField",
          "name": "virtualAgent",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v6/*: any*/),
                "concreteType": "VirtualAgentFeatures",
                "kind": "LinkedField",
                "name": "virtualAgentEntitlements",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "isGateIntentTemplatesBehindAiToggleEnabled",
                        "variableName": "isGateIntentTemplatesBehindAiToggleEnabled"
                      }
                    ],
                    "kind": "FragmentSpread",
                    "name": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_virtualAgentFeaturesRef"
                  }
                ]
              },
              "action": "THROW",
              "path": "virtualAgent.virtualAgentEntitlements"
            }
          ]
        },
        "action": "THROW",
        "path": "virtualAgent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiVirtualAgentIntentTemplatesQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v7/*: any*/),
                "concreteType": "VirtualAgentIntentTemplatesConnection",
                "kind": "LinkedField",
                "name": "intentTemplates",
                "plural": false,
                "selections": [
                  {
                    "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasDiscoveredTemplates"
                      }
                    ]
                  },
                  {
                    "condition": "isDiscoveredTemplatesTimestampEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "lastDiscoveredTemplatesGenerationTime"
                      }
                    ]
                  },
                  {
                    "concreteType": "VirtualAgentIntentTemplateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "VirtualAgentIntentTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "noOfQuestions"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "intentTemplates(first:20)"
              },
              {
                "args": (v7/*: any*/),
                "handle": "connection",
                "key": "content_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar_SidebarContent_intentTemplates",
                "kind": "LinkedHandle",
                "name": "intentTemplates"
              },
              (v8/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
          {
            "args": (v6/*: any*/),
            "concreteType": "VirtualAgentFeatures",
            "kind": "LinkedField",
            "name": "virtualAgentEntitlements",
            "plural": false,
            "selections": [
              {
                "condition": "isGateIntentTemplatesBehindAiToggleEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAiEnabledInAdminHub"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8789ab3f986d4f369f91bdc4d71ace921807eaec7638f0e5dde21bdca1c34e17",
    "metadata": {},
    "name": "uiVirtualAgentIntentTemplatesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "78ecd07324c304fbf388410adf2d2c40";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
